<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    var loading = document.getElementById("loading");
    loading.remove();
  },
};
</script>